var Ractive = require('ractive');
var component = module;

  component.exports ={
    data:function() {
      return {         
					Design : "Simple",
					doActions: '',
          Meta: {
            Columns: []
          },
          Row: {},
          Lng: SiteLng
        }
    }
  }

component.exports.template = {v:4,t:[{t:4,f:[{p:[2,1,32],t:7,e:"div",m:[{n:"class",f:"d-flex justify-content-between canvas-footer flex-nowrap gap-2",t:13}],f:[{t:4,f:[{p:[4,2,138],t:7,e:"button",m:[{n:"class",f:"btn btn-success ex-action",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.set(\"doActions\",\"doSave\")]"}},t:70}],f:[{t:3,r:"Lng.Page.Detail.Save.Text",p:[4,88,224]}]}],n:50,r:"Meta.ListChange",p:[3,2,111]}," "]}],n:50,x:{r:["Design"],s:"_0==\"SimpleRight\""},p:[1,1,0]},{t:4,f:[{t:4,f:[{p:[11,2,487],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-primary",t:13},{n:"data-bs-dismiss",f:"modal",t:13},{n:"data-dismiss",f:"modal",t:13}],f:["Snimi"]}],n:50,r:"Meta.ListChange",p:[10,2,460]}," ",{p:[13,2,605],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-secondary",t:13},{n:"data-bs-dismiss",f:"modal",t:13},{n:"data-dismiss",f:"modal",t:13}],f:["zatvori"]}],n:50,x:{r:["Design"],s:"_0==\"SimpleModal\""},p:[9,1,427]}],e:{"[_0.set(\"doActions\",\"doSave\")]":function (_0){return([_0.set("doActions","doSave")]);},"_0==\"SimpleRight\"":function (_0){return(_0=="SimpleRight");},"_0==\"SimpleModal\"":function (_0){return(_0=="SimpleModal");}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Element/Actions.html
// module id = 20
// module chunks = 0